var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.27,149.79H65.14m80.45-32.95,33.75-5.8m-9.67,49.64h0A17.92,17.92,0,0,1,149,146l-10.4-60.53a17.93,17.93,0,1,1,35.35-6.08L184.32,140A17.94,17.94,0,0,1,169.67,160.68ZM58.35,84.89,95.66,111m31.61,38.83A31.07,31.07,0,1,1,96.2,118.72,31.08,31.08,0,0,1,127.27,149.79ZM63.16,151.2a23.84,23.84,0,0,1-28.94-35.57L81,48.71A23.85,23.85,0,1,1,120.08,76L89.89,119.44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/PILLS.bc3092478addf1a55209d7729b26d45b.svg";
export { ForwardRef as ReactComponent };